<app-banner></app-banner>

<section class="main-section confirmation white-bg">
    <div class="width-container">
        <h2 id="confirm-header" tabindex="-1" class="no-outline" [innerHtml]="'CONFIRM.HEAD' | translate:data"></h2>
        <p [innerHtml]="'CONFIRM.DESC' | translate:data"></p>
        <p [innerHtml]="'CONFIRM.REGISTRATION_DATE' | translate:data"></p>
        <!-- <p [innerHtml]="'CONFIRM.FOOTNOTE' | translate:data"></p> -->
        <img [src]="'CONFIRM.CARD_IMG' | translate:data"  alt="United MilesagePlus Card"/>
         <!-- <img src="../../public/images/cards/MileagePlus_Card_Generic_Visa.png" /> -->
    </div>
</section>